export const formatCurrency = (value) => {
  if (value === null || value === undefined || isNaN(value)) return '0';
  return new Intl.NumberFormat('id-ID', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(value);
};

export const formatNumber = (value) => {
  if (value === null || value === undefined || isNaN(value)) return '0';
  return new Intl.NumberFormat('id-ID').format(value);
};

export const formatRupiahInput = (val) => {
  if (val === null || val === undefined || val === '') return '';
  const str = String(val);
  const [intPart, decPart] = str.split('.');
  const cleanInt = intPart.replace(/\D/g, '');
  if (!cleanInt && decPart === undefined) return '';
  const formattedInt = cleanInt ? new Intl.NumberFormat('id-ID').format(Number(cleanInt)) : '0';
  if (decPart !== undefined) {
    return `${formattedInt},${decPart}`;
  }
  return formattedInt;
};

export const parseRupiahInput = (inputValue) => {
  if (!inputValue && inputValue !== 0) return '';
  const str = String(inputValue).trim();
  if (str === '') return '';

  if (str.includes(',')) {
    const parts = str.split(',');
    const intRaw = parts[0].replace(/\D/g, '');
    const decRaw = parts.slice(1).join('').replace(/\D/g, '').slice(0, 2);
    if (!intRaw && !decRaw) return '';
    return str.endsWith(',') && decRaw === '' ? `${intRaw || '0'}.` : `${intRaw || '0'}.${decRaw}`;
  }

  if (str.endsWith('.')) {
    const intRaw = str.replace(/\D/g, '');
    return `${intRaw || '0'}.`;
  }

  const intRaw = str.replace(/\D/g, '');
  return intRaw;
};
